import * as DiffType from 'entities/DiffType'
import _flow from 'lodash/flow'
import _difference from 'lodash/fp/difference'
import _map from 'lodash/fp/map'
import _identity from 'lodash/identity'
import _keyBy from 'lodash/keyBy'
import _keys from 'lodash/keys'
import _mapValues from 'lodash/mapValues'

import DetailedDiff from '../@types/DetailedDiff'

const diffArrays = <T>(original: T[], current: T[], getUniqueKey: (value: T) => string = _identity): DetailedDiff => {
  const originalByKey = _keyBy(original, getUniqueKey)
  const currentByKey = _keyBy(current, getUniqueKey)

  const changesFromOriginal = _mapValues(originalByKey, (value, key) => DiffType.getType(value, currentByKey[key]))

  const added = _flow(
    _difference(_keys(currentByKey)),
    _map((key) => [key, DiffType.Type.ADDED]),
    Object.fromEntries
  )(_keys(originalByKey))

  return {
    ...changesFromOriginal,
    ...added,
  }
}

export default diffArrays
